<template>
  <path
    fill="currentColor"
    d="M1.875 5.625C1.52982 5.625 1.25 5.34518 1.25 5C1.25 4.65482 1.52982 4.375 1.875 4.375L18.1244 4.375C18.1245 4.375 18.125 4.375 18.125 5L18.1244 4.375C18.2902 4.375 18.4497 4.44085 18.5669 4.55806C18.6842 4.67527 18.75 4.83424 18.75 5V15C18.75 15.3452 18.4702 15.625 18.125 15.625V15C18.125 15.625 18.1251 15.625 18.125 15.625L1.875 15.625C1.52982 15.625 1.25 15.3452 1.25 15C1.25 14.6548 1.52983 14.375 1.875 14.375H17.5V5.625L1.875 5.625Z" />
</template>
